/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/cpanel/js/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1356);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1356:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hideLoader = function hideLoader() {
    var hideLoaderEvent = new CustomEvent('loader::destroy', { detail: {
            domNode: document.body,
            loaderType: 'fullpage'
        } });

    document.dispatchEvent(hideLoaderEvent);
};

var showLoader = function showLoader() {
    var showLoaderEvent = new CustomEvent('loader::apply', { detail: {
            domNode: document.body,
            loaderType: 'fullpage',
            loaderText: '<h3>' + LANG_common_processing_request + '</h3>'
        } });

    document.dispatchEvent(showLoaderEvent);
};

var manageResponse = function manageResponse(response) {
    if (typeof response.has_password === 'boolean') {
        var locationSearch = window.location.search,
            qsParts = [];
        if (locationSearch) {
            qsParts.push('qs=' + encodeURIComponent(locationSearch));
        }
        var username = '',
            usernameString = void 0;
        if (typeof response.username !== 'undefined') {
            username = response.username;
            qsParts.push('username=' + response.username);
        }

        var qs = qsParts.length > 0 ? '?' + qsParts.join('&') : '';
        if (response.has_password === true) {
            showLoader();
            $.ajax({
                type: 'GET',
                url: apiUrl + '/lsapi/v1/misc/keycloakLoginPage' + qs,
                headers: { 'auth-token': at },
                success: function success(response) {
                    hideLoader();
                    if (typeof response.redirect_url === 'undefined') {
                        alert('An error has occurred');
                        return;
                    }

                    window.location.href = response.redirect_url;
                }
            });
        } else {
            window.location.href = apiUrl + '/cpanel/?s=&m=login&c=main&a=resetPasswordSso&em=' + encodeURIComponent(username);
        }
    } else {
        $('#p-label-warning').html(LANG_warning_sso_user_not_present).show();
    }
};

var checkEmail1 = function checkEmail1(val) {
    return val.match(/^([a-z0-9\-_.äöüß_\.\+-])+@(([a-z0-9_-])+\.)+[a-z]{2,6}$/i) !== null;
};

var ssoRoutines = function ssoRoutines() {
    $("#login_user").focus();

    $('#login-form').on('submit', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (!checkEmail1($("#login_user").val())) {
            error1($("#login_user"));
            return false;
        }

        $('#p-label-warning').hide();
        showLoader();
        $.ajax({
            type: 'GET',
            url: apiUrl + '/lsapi/v1/misc/ssoStatusCheck?email=' + encodeURIComponent($('#login_user').val()),
            headers: { 'auth-token': at },
            success: function success(response) {
                hideLoader();
                manageResponse(response);
            }
        });
    });

    $('#reset-password-form').on('submit', function (event) {
        event.preventDefault();
        showLoader();
        $.ajax({
            type: 'POST',
            url: apiUrl + '/lsapi/v1/misc/ssoResetPassword',
            data: 'email=' + encodeURIComponent($('#login_user').val()),
            headers: { 'auth-token': at },
            success: function success(response) {
                hideLoader();
                $('.label-info2').removeClass('label-error2').html(LANG_info_sso_reset_password_email_sent + '<span class="glyphicon glyphicon-thumbs-up form-control-feedback"></span>');
                $('#reset-password-form').remove();
                window.setTimeout(function () {
                    window.location.href = apiUrl + '/cpanel/';
                }, 10000);
            },
            error: function error(jqXHR, textStatus, errorThrown) {
                hideLoader();
                $('.label-info2').addClass('label-error2').html(LANG_info_sso_reset_password_email_error + '<span class="glyphicon glyphicon-thumbs-down form-control-feedback"></span>');
            }
        });
    });
};

var apiUrl = window.location.protocol + "//" + window.location.host,
    at = 'ziHlFFeGSEvDSD3YqZREOfAbzt6I6oBJq8c26uEvYySp5whizUPu6alQRgKCasz3';
$(document).ready(ssoRoutines);

/***/ })

/******/ });


// WEBPACK FOOTER //
// ../../js/dist/pages/sso.js